export const dateFormat =(date)=>{
    const d = new Date(date);
    return d.getFullYear()+'. '+(d.getMonth()<9?'0'+(d.getMonth()+1):(d.getMonth()+1)) +'. '+(d.getDate()<10?"0"+d.getDate():d.getDate());
}